export function isRenderField({ input, field, }) {
    const { condition } = input;
    const { value } = field(condition?.name || '');
    return !condition || condition?.values?.find((_) => _ === (value?.key ?? value));
}
//# sourceMappingURL=isRenderField.js.map